import { hideMenu, toggleMobileMenu, setStickyHeader } from './modules/menuToggle';
import { videoLazyLoading } from './modules/videoLazyLoading';
import { debounce } from "./utils/delays";
import { initAnim } from "./modules/animations";
import { smoothScroll } from "./modules/smoothScrollGsap";
import { updateScrollTriger } from "./modules/updateScrollTriger";
import { handleFormSubmit } from './modules/customForm';
import { Cursor } from './modules/borderHover';
import { initRevealText } from './modules/revealText';
import { disableScroll, enableScroll } from './utils/scroll';

const windowWidth = window.innerWidth;
const header = document.querySelector('.header');
const videoBg = header.querySelector('.sk-bg-video');
const navbarToggler = document.querySelector('.nav-toggler');
const lazyVideos = document.querySelectorAll('video.lazy');
const borderHoverWrap = document.querySelectorAll('.border-hover-wrap');

document.addEventListener("DOMContentLoaded", function() {
  (navbarToggler && header) && toggleMobileMenu(navbarToggler, header, videoBg);
  handleFormSubmit().init();
  borderHoverWrap.length > 0 && borderHoverWrap.forEach(wrap => new Cursor( wrap ));
  initAnim();
  document.querySelector('body').style.opacity = 1;
});

window.addEventListener('resize', () => {
  debounce((window.innerWidth != windowWidth && window.innerWidth >= 1025 && navbarToggler.classList.contains('menu-open')) && hideMenu(navbarToggler, header), 100);
  debounce(updateScrollTriger(), 500);
});

window.addEventListener('scroll', () => {
  header && setStickyHeader(header);
});

window.onload = () => {
  smoothScroll();
  header && setStickyHeader(header);
  lazyVideos.length > 0 && videoLazyLoading(lazyVideos);
  initRevealText().init();
  setTimeout(() => updateScrollTriger(), 500);

  setTimeout(() => {
    const hbForms = [...document.querySelectorAll('.hs-form-iframe')];

    if(hbForms.length > 0) {
      hbForms.forEach((formWrap) => {
        const hbForm = formWrap.contentWindow.document.querySelector('.hs-form');
        hbForm && hbForm.addEventListener('submit', () => {
          disableScroll();
          setTimeout(() => enableScroll(), 100);
        })
      })
    }
  }, 1500);
};

